<template>
    <div id="SCRM">
        <tabtop></tabtop>
        <div class="SCRM1"><img :src="url+banner.images[2]" alt=""  @click="jumpbannerpage(banner.url,2)"></div>
        <div class="SCRM2">
            <p class="title">我们可以帮助您解决以下痛点</p>
            <ul>
                <li v-for="(item,index) in SCRM2" :key="index" class="wow animate__animated animate__fadeIn">
                    <img :src="item.img" alt="">
                    <p class="p1">{{item.title}}</p>
                </li>
            </ul>
        </div>
        <div class="SCRM3">
            <p class="title">客户CRM</p>
            <p class="subtitle">依托于企业微信的智能CRM系统，覆盖售前、售中、售后全流程一体化的客户运营管理平台</p>
            <img src="@/assets/product/scrm2img5.png" alt="" class="img1">
            <ul v-for="(item,index) in SCRM3" :key="index" :class="[index%2==0?'other':'','wow','animate__animated','animate__fadeIn']">
                <li class="list1">
                    <p class="p1">{{item.title}}</p>
                    <p class="p2">{{item.subtitle}}</p>
                    <button  @click="submit(false)">免费试用</button>
                </li>
                <li><img :src="item.img" alt="" class="cover"></li>
            </ul>
        </div>
        <div class="SCRM4">
            <div class="SCRM4Box">
                <p class="title">管理企微店铺与企微社群</p>
                <img :src="SCRM4" alt="" class="wow animate__animated animate__fadeIn">
            </div>
        </div>
        <div class="SCRM5">
            <div class="SCRM5Box">
                <p class="title">精准用户画像了解客户痛点</p>
                <img :src="SCRM5" alt="" class="wow animate__animated animate__fadeIn">
            </div>
        </div>
        <div class="SCRM3">
            <p class="title">企业微信CRM相关功能总览</p>
            <p class="subtitle">实现客户精准管理，挖掘客户价值，透析客户行为，精准跟进客户，实现高效运营转化</p>
            <img src="@/assets/product/scrm2img12.png" alt="" class="img1">
            <ul v-for="(item,index) in SCRM6" :key="index" :class="[index%2==0?'other':'','wow','animate__animated','animate__fadeIn']">
                <li class="list1">
                    <p class="p1">{{item.title}}</p>
                    <p class="p2">{{item.subtitle}}</p>
                    <button @click="submit(false)">免费试用</button>
                </li>
                <li><img :src="item.img" alt="" class="cover"></li>
            </ul>
        </div>
        <webbottom></webbottom>
        <mydialog v-if="showtc2" @tcstatus="tcstatus" :dialogVisible1="tcshow"></mydialog>
    </div>
</template>

<script>
var that
import { rotationmap } from '@/api/api'
import mydialog from '@/components/dialog/dialog.vue'
import tabtop from '@/components/tab/tab.vue'
import webbottom from '@/components/bottom/bottom.vue'
export default {
    components: {
        tabtop,
        webbottom,
        mydialog
    },
    data(){
        return {
            url : window.url,
            banner:{},
            showtc2:false,
            tcshow:true,
            SCRM2:[
                {
                    img:require("@/assets/product/scrm2img1.png"),
                    title:"获客难，缺乏高效引流拓客工具",
                },
                {
                    img:require("@/assets/product/scrm2img2.png"),
                    title:"留存低，无法精准了解客户需求",
                },
                {
                    img:require("@/assets/product/scrm2img3.png"),
                    title:"转化差，缺乏多渠道高效转化工具",
                },
                {
                    img:require("@/assets/product/scrm2img4.png"),
                    title:"管理烦，数据管理和员工管理",
                }
            ],
            SCRM3:[
                {
                    img:require("@/assets/product/scrm2img6.png"),
                    title:"销售漏斗",
                    subtitle:"全渠道获客，销售线索自动入库，客户关系留在企业，各层次客户转化率形成漏斗图"
                },
                {
                    img:require("@/assets/product/scrm2img7.png"),
                    title:"客户分层",
                    subtitle:"根据客户情况和跟踪情况对客户进行分层管理提高销售效率"
                },
                {
                    img:require("@/assets/product/scrm2img8.png"),
                    title:"客户公海",
                    subtitle:"建立客户回收机制和规则，支持大小公海和部门不同公海功能"
                },
                {
                    img:require("@/assets/product/scrm2img9.png"),
                    title:"商机管理",
                    subtitle:"销售线索到销售商机的全方位管理，全面管理跟踪客户，不遗漏数据"
                }
            ],
            SCRM4:require("@/assets/product/scrm2img10.png"),
            SCRM5:require("@/assets/product/scrm2img11.png"),
            SCRM6:[
                {
                    img:require("@/assets/product/scrm2img13.png"),
                    title:"客户画像",
                    subtitle:"追踪客户行为轨迹，建立完整用户画像，洞察客户真实需求"
                },
                {
                    img:require("@/assets/product/scrm2img14.png"),
                    title:"客户营销漏斗",
                    subtitle:"自定义客户阶段，高效跟进客户，帮助企业提高销售效率"
                },
                {
                    img:require("@/assets/product/scrm2img15.png"),
                    title:"跟进提醒",
                    subtitle:"定时向员工推送跟进通知，避免因工作繁忙忘记跟进而错失成单机会"
                },
                {
                    img:require("@/assets/product/scrm2img16.png"),
                    title:"线索导入",
                    subtitle:"一键导入线索至公海，管理员可将线索分配给员工或员工在公海里认领"
                },
                {
                    img:require("@/assets/product/scrm2img17.png"),
                    title:"客户回收机制",
                    subtitle:"未及时跟进的客户自动退回公海，改由其他销售跟进，提升商机转化率"
                }
            ],
        }
    },
    mounted(){
        that = this
        rotationmap({'type':8}).then((response) => {
            response.data.data[0].images = response.data.data[0].images.split(',')
            that.banner = response.data.data[0]
            this.$nextTick(function(){
                 //初始化动画
                if(this.$route.query.id){
                    document.getElementById(this.$route.query.id).scrollIntoView();
                }
                this.$wow.init()
            })
        })
    },
    methods:{
        tcstatus(e){
            this.showtc2 = e
        },
        submit(e){
            this.showtc2 = true
            this.tcshow = e
        },
        jumpbannerpage(e,y){
            let url = e.split(';')
            if(url[y] != this.$route.path) {
                this.$router.push(url[y])
            }
        } 
    }
}
</script>

<style lang="less">
:root {
    --web-title-fontsize: 30px;
    --web-subtitle-fontsize: 22px;
    --web-text-fontsize: 16px;
} 
@media (min-width:750px) {
    #SCRM{
        .SCRM1{
            width: 100%;
            img{
                width: 100%;
            }
        }
        .SCRM2{
            width: 1400px;
            margin:60px auto 0;
            .title{
                font-size: var(--web-title-fontsize);
                font-weight: normal;
                color: #222222;
                text-align: center;
            }
            ul{
                display: flex;
                justify-content: space-between;
                margin-top: 50px;
                li{
                    box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                    border-radius:12px;
                    padding: 46px 38px 52px;
                    text-align: center;
                    font-size: var(--web-subtitle-fontsize);
                    font-weight: normal;
                    color: #333;
                    width: 300px;
                    img{
                        width: 120px;
                        margin-bottom: 20px;
                    }
                }
                li:hover{
                    transform: translateY(-20px);
                    background: linear-gradient(180deg, #D8EEFF 0%, #D6E9FF 100%);
                    box-shadow: 0px 12px 20px 1px #C5D9FF;
                }

            }
        }
        .SCRM3{
            width: 1400px;
            margin:60px auto 0;
            .title{
                font-size: var(--web-title-fontsize);
                font-weight: normal;
                color: #222222;
                text-align: center;
            }
            .subtitle{
                font-size: var(--web-subtitle-fontsize);
                font-weight: normal;
                color: #949494;
                text-align: center;
                margin-top: 12px;
            }
            .img1{
                width: 100%;
                margin-top: 20px;
                margin-bottom: 20px;
            }
            ul{
                display: flex;
                justify-content: space-between;
                margin-bottom: 70px;
                li{
                    flex:0 0 50%;
                    .cover{
                        width: 100%;
                    }
                    .p1{
                        font-size: var(--web-title-fontsize);
                        font-weight: 500;
                        color: #355EFC;
                        margin-top: 98px;
                    }
                    .p2{
                        padding-left: 24px;
                        position: relative;
                        font-size: var(--web-subtitle-fontsize);
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #1A1A1A;
                        width: 417px;
                        margin-top: 16px;
                    }
                    .p2::after{
                        content:"";
                        display: block;
                        width: 8px;
                        height: 8px;
                        position: absolute;
                        border: 4px solid #DBE2FE;
                        background-color: #355EFC;
                        border-radius: 50%;
                        top: 5px;
                        left: 0;
                    }
                    button{
                        width: 160px;
                        height: 46px;
                        background: #355EFC;
                        border-radius: 61px 61px 61px 61px;
                        font-size: var(--web-text-fontsize);
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        margin-top: 35px;
                        cursor: pointer;
                    }
                }
            }
            .other{
                flex-direction: row-reverse;
                .list1{
                    padding-left: 50px;
                }
            }
        }
        .SCRM4{
            background: #F6FAFF;
            padding: 35px 0 50px;
            .SCRM4Box{
                width: 1400px;
                margin:0 auto;
                .title{
                    font-size: var(--web-title-fontsize);
                    font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
                    font-weight: 800;
                    color: #1A1A1A;
                    text-align: center;
                    margin-bottom: 40px;
                }
                img{
                    width: 970px;
                    display: block;
                    margin:0 auto;
                }
            }
        }
        .SCRM5{
            background: #FAFAFA;
            padding: 35px 0 50px;
            .SCRM5Box{
                width: 1400px;
                margin:0 auto;
                .title{
                    font-size: var(--web-title-fontsize);
                    font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
                    font-weight: 800;
                    color: #1A1A1A;
                    text-align: center;
                    margin-bottom: 40px;
                }
                img{
                    width: 970px;
                    display: block;
                    margin:0 auto;
                }
            }
        }
    }
}
@media screen and (max-width:750px) {
    #SCRM{
        .SCRM1{
            width: 100%;
            img{
                width: 100%;
            }
        }
        .SCRM2{
            width: 100%;
            margin:1.25rem auto 0;
            .title{
                font-size: 1.5rem;
                font-weight: normal;
                color: #222222;
                text-align: center;
            }
            ul{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                margin:1.25rem 0.625rem;
                li{
                    box-shadow: 0rem 0.1875rem 0.375rem 0.0625rem rgba(0,0,0,0.16);
                    border-radius: 1.25rem;
                    padding:1.25rem;
                    text-align: center;
                    font-size: 0.8125rem;
                    font-weight: normal;
                    color: #FFFFFF;
                    flex: 0 0 45%;
                    margin-bottom: 1.25rem;
                    img{
                        width: 2.5rem;
                        margin-bottom: 1.25rem;
                    }
                }
                li:hover{
                    transform: translateY(-1.25rem);
                }
                li:nth-child(1){
                    background: linear-gradient(136deg, #30B3B6 0%, #65E1E6 100%);
                }
                li:nth-child(2){
                    background: linear-gradient(138deg, #3B58E0 0%, #8499F8 100%);
                }
                li:nth-child(3){
                    background: linear-gradient(137deg, #F3760C 0%, #FFB06D 100%);
                }
                li:nth-child(4){
                    background: linear-gradient(136deg, #2CBB2C 0%, #8BF18C 100%);
                }
            }
        }
        .SCRM3{
            width: 100%;
            margin:1.25rem auto 0;
            .title{
                font-size: 1.5rem;
                font-weight: normal;
                color: #222222;
                text-align: center;
            }
            .subtitle{
                font-size: 1.25rem;
                font-weight: normal;
                color: #949494;
                text-align: center;
                margin-top: 0.75rem;
                padding: 0 0.625rem;
            }
            .img1{
                width: 100%;
                margin-top: 1.25rem;
                margin-bottom: 1.25rem;
            }
            ul{
                width: 95%;
                margin:0 auto 2.5rem;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                li{
                    flex:0 0 100%;
                    .cover{
                        width: 100%;
                    }
                    .p1{
                        font-size: 1.5rem;
                        font-weight: 500;
                        color: #355EFC;
                    }
                    .p2{
                        padding-left: 1.5rem;
                        position: relative;
                        font-size: 0.75rem;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #1A1A1A;
                        margin-top: 1rem;
                    }
                    .p2::after{
                        content:"";
                        display: block;
                        width: 0.5rem;
                        height: 0.5rem;
                        position: absolute;
                        border: 4px solid #DBE2FE;
                        background-color: #355EFC;
                        border-radius: 50%;
                        top: 0.3125rem;
                        left: 0;
                    }
                    button{
                        width: 6.25rem;
                        height: 2.25rem;
                        background: #355EFC;
                        border-radius: 3.8125rem 3.8125rem 3.8125rem 3.8125rem;
                        font-size: 1rem;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        margin: 1.25rem 0;
                    }
                }
            }
        }
        .SCRM4{
            background: #F6FAFF;
            padding: 1.25rem 0 1.25rem;
            .SCRM4Box{
                width: 100%;
                margin:0 auto;
                .title{
                    font-size: 1.5rem;
                    font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
                    font-weight: 800;
                    color: #1A1A1A;
                    text-align: center;
                    margin-bottom: 1.25rem;
                }
                img{
                    width: 90%;
                    display: block;
                    margin:0 auto;
                }
            }
        }
        .SCRM5{
            background: #FAFAFA;
            padding: 1.25rem 0;
            .SCRM5Box{
                width: 100%;
                margin:0 auto;
                .title{
                    font-size: 1.5rem;
                    font-family: Source Han Sans CN-Heavy, Source Han Sans CN;
                    font-weight: 800;
                    color: #1A1A1A;
                    text-align: center;
                    margin-bottom: 2.5rem;
                }
                img{
                    width: 90%;
                    display: block;
                    margin:0 auto;
                }
            }
        }
    }
}
</style>